export default __webpack_public_path__ + "static/HeaderAnimationLoop-b3547fffc62f7fc091abc4fb5da69228.mp4";